import {FC} from 'react'
import {formatDateByZone} from '../../../../template/helpers/FormatDateZoneHelpers'
import {usersAPI} from '../../../../services/UsersService'

type Props = {
  data?: string
}

const CDRCallStart: FC<Props> = ({data}) => {
  const {data: currentUser} = usersAPI.useFetchGetMeQuery()

  function dateTime(date: string) {
    return formatDateByZone(date, currentUser?.language || 'en', currentUser?.time_zone || 'UTC')
  }

  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex justify-content-start flex-column me-3 text-gray-800 small'>{dateTime(data!)}</div>
    </div>
  )
}

export {CDRCallStart}
